module.exports = __webpack_public_path__ + "75a1bbe54ac5ea2d93cde4e1fddc7ba5.png";